export default "__VITE_ASSET__69afa484__"